import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "proto/txauth/common/device/devices.proto" (package "proto.txauth.common.device", syntax proto3)
// tslint:disable
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "@finam/tx-proto-lib-google-wellknown/google/protobuf/timestamp_pb";
/**
 * https://wiki.finam.ru/pages/viewpage.action?pageId=189399106
 *
 * @generated from protobuf enum proto.txauth.common.device.DeviceInfoKey
 */

export var DeviceInfoKey;

(function (DeviceInfoKey) {
  /**
   * @generated from protobuf enum value: PLATFORM = 0;
   */
  DeviceInfoKey[DeviceInfoKey["PLATFORM"] = 0] = "PLATFORM";
  /**
   * @generated from protobuf enum value: VENDOR = 1;
   */

  DeviceInfoKey[DeviceInfoKey["VENDOR"] = 1] = "VENDOR";
  /**
   * @generated from protobuf enum value: MODEL = 2;
   */

  DeviceInfoKey[DeviceInfoKey["MODEL"] = 2] = "MODEL";
  /**
   * @generated from protobuf enum value: OS_VERSION = 3;
   */

  DeviceInfoKey[DeviceInfoKey["OS_VERSION"] = 3] = "OS_VERSION";
  /**
   * @generated from protobuf enum value: API_LEVEL = 4;
   */

  DeviceInfoKey[DeviceInfoKey["API_LEVEL"] = 4] = "API_LEVEL";
  /**
   * @generated from protobuf enum value: BUILD_ID = 5;
   */

  DeviceInfoKey[DeviceInfoKey["BUILD_ID"] = 5] = "BUILD_ID";
  /**
   * @generated from protobuf enum value: FINGERPRINT = 6;
   */

  DeviceInfoKey[DeviceInfoKey["FINGERPRINT"] = 6] = "FINGERPRINT";
  /**
   * @generated from protobuf enum value: ANDROID_ID = 7;
   */

  DeviceInfoKey[DeviceInfoKey["ANDROID_ID"] = 7] = "ANDROID_ID";
  /**
   * @generated from protobuf enum value: SERIAL_NUMBER = 8;
   */

  DeviceInfoKey[DeviceInfoKey["SERIAL_NUMBER"] = 8] = "SERIAL_NUMBER";
  /**
   * @generated from protobuf enum value: ROOTED = 9;
   */

  DeviceInfoKey[DeviceInfoKey["ROOTED"] = 9] = "ROOTED";
  /**
   * @generated from protobuf enum value: SCREEN_RESOLUTION = 10;
   */

  DeviceInfoKey[DeviceInfoKey["SCREEN_RESOLUTION"] = 10] = "SCREEN_RESOLUTION";
  /**
   * @generated from protobuf enum value: RAM = 11;
   */

  DeviceInfoKey[DeviceInfoKey["RAM"] = 11] = "RAM";
  /**
   * @generated from protobuf enum value: STORAGE_VOLUME = 12;
   */

  DeviceInfoKey[DeviceInfoKey["STORAGE_VOLUME"] = 12] = "STORAGE_VOLUME";
  /**
   * @generated from protobuf enum value: CPU_MODEL = 13;
   */

  DeviceInfoKey[DeviceInfoKey["CPU_MODEL"] = 13] = "CPU_MODEL";
  /**
   * @generated from protobuf enum value: CPU_ARCH = 14;
   */

  DeviceInfoKey[DeviceInfoKey["CPU_ARCH"] = 14] = "CPU_ARCH";
  /**
   * @generated from protobuf enum value: CPU_COUNT = 15;
   */

  DeviceInfoKey[DeviceInfoKey["CPU_COUNT"] = 15] = "CPU_COUNT";
  /**
   * @generated from protobuf enum value: GPU_VENDOR = 16;
   */

  DeviceInfoKey[DeviceInfoKey["GPU_VENDOR"] = 16] = "GPU_VENDOR";
  /**
   * @generated from protobuf enum value: GPU_RENDERER = 17;
   */

  DeviceInfoKey[DeviceInfoKey["GPU_RENDERER"] = 17] = "GPU_RENDERER";
  /**
   * @generated from protobuf enum value: IMEI = 19;
   */

  DeviceInfoKey[DeviceInfoKey["IMEI"] = 19] = "IMEI";
  /**
   * @generated from protobuf enum value: CARRIER = 20;
   */

  DeviceInfoKey[DeviceInfoKey["CARRIER"] = 20] = "CARRIER";
  /**
   * @generated from protobuf enum value: CARRIER_CODE = 21;
   */

  DeviceInfoKey[DeviceInfoKey["CARRIER_CODE"] = 21] = "CARRIER_CODE";
  /**
   * @generated from protobuf enum value: CARRIER_COUNTRY = 22;
   */

  DeviceInfoKey[DeviceInfoKey["CARRIER_COUNTRY"] = 22] = "CARRIER_COUNTRY";
  /**
   * @generated from protobuf enum value: LANG = 23;
   */

  DeviceInfoKey[DeviceInfoKey["LANG"] = 23] = "LANG";
  /**
   * @generated from protobuf enum value: TIMEZONE = 24;
   */

  DeviceInfoKey[DeviceInfoKey["TIMEZONE"] = 24] = "TIMEZONE";
  /**
   * @generated from protobuf enum value: COUNTRY = 25;
   */

  DeviceInfoKey[DeviceInfoKey["COUNTRY"] = 25] = "COUNTRY";
  /**
   * @generated from protobuf enum value: APP_NAME = 26;
   */

  DeviceInfoKey[DeviceInfoKey["APP_NAME"] = 26] = "APP_NAME";
  /**
   * @generated from protobuf enum value: APP_VERSION = 27;
   */

  DeviceInfoKey[DeviceInfoKey["APP_VERSION"] = 27] = "APP_VERSION";
  /**
   * @generated from protobuf enum value: PLAY_SERVICES_VERSION = 28;
   */

  DeviceInfoKey[DeviceInfoKey["PLAY_SERVICES_VERSION"] = 28] = "PLAY_SERVICES_VERSION";
  /**
   * @generated from protobuf enum value: OS_USER_NAME = 29;
   */

  DeviceInfoKey[DeviceInfoKey["OS_USER_NAME"] = 29] = "OS_USER_NAME";
  /**
   * @generated from protobuf enum value: TXAUTH_WIDGET_VERSION = 30;
   */

  DeviceInfoKey[DeviceInfoKey["TXAUTH_WIDGET_VERSION"] = 30] = "TXAUTH_WIDGET_VERSION";
})(DeviceInfoKey || (DeviceInfoKey = {})); // @generated message type with reflection information, may provide speed optimized methods


var LoggedDevice$Type = /*#__PURE__*/function (_MessageType) {
  _inherits(LoggedDevice$Type, _MessageType);

  var _super = _createSuper(LoggedDevice$Type);

  function LoggedDevice$Type() {
    _classCallCheck(this, LoggedDevice$Type);

    return _super.call(this, "proto.txauth.common.device.LoggedDevice", [{
      no: 1,
      name: "info",
      kind: "map",
      K: 5
      /*ScalarType.INT32*/
      ,
      V: {
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/

      }
    }, {
      no: 3,
      name: "name",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 4,
      name: "remote_ip",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 5,
      name: "updated",
      kind: "message",
      T: function T() {
        return Timestamp;
      }
    }, {
      no: 6,
      name: "provider",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 7,
      name: "verified",
      kind: "scalar",
      T: 8
      /*ScalarType.BOOL*/

    }, {
      no: 8,
      name: "key_id",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 9,
      name: "created",
      kind: "message",
      T: function T() {
        return Timestamp;
      }
    }]);
  }

  _createClass(LoggedDevice$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        info: {},
        name: "",
        remoteIp: "",
        provider: "",
        verified: false,
        keyId: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag = reader.tag(),
            _reader$tag2 = _slicedToArray(_reader$tag, 2),
            fieldNo = _reader$tag2[0],
            wireType = _reader$tag2[1];

        switch (fieldNo) {
          case
          /* map<int32, string> info */
          1:
            this.binaryReadMap1(message.info, reader, options);
            break;

          case
          /* string name */
          3:
            message.name = reader.string();
            break;

          case
          /* string remote_ip */
          4:
            message.remoteIp = reader.string();
            break;

          case
          /* google.protobuf.Timestamp updated */
          5:
            message.updated = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updated);
            break;

          case
          /* string provider */
          6:
            message.provider = reader.string();
            break;

          case
          /* bool verified */
          7:
            message.verified = reader.bool();
            break;

          case
          /* string key_id */
          8:
            message.keyId = reader.string();
            break;

          case
          /* google.protobuf.Timestamp created */
          9:
            message.created = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.created);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "binaryReadMap1",
    value: function binaryReadMap1(map, reader, options) {
      var len = reader.uint32(),
          end = reader.pos + len,
          key,
          val;

      while (reader.pos < end) {
        var _reader$tag3 = reader.tag(),
            _reader$tag4 = _slicedToArray(_reader$tag3, 2),
            fieldNo = _reader$tag4[0],
            wireType = _reader$tag4[1];

        switch (fieldNo) {
          case 1:
            key = reader.int32();
            break;

          case 2:
            val = reader.string();
            break;

          default:
            throw new globalThis.Error("unknown map entry field for field proto.txauth.common.device.LoggedDevice.info");
        }
      }

      map[key !== null && key !== void 0 ? key : 0] = val !== null && val !== void 0 ? val : "";
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* map<int32, string> info = 1; */
      for (var _i = 0, _Object$keys = Object.keys(message.info); _i < _Object$keys.length; _i++) {
        var k = _Object$keys[_i];
        writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k)).tag(2, WireType.LengthDelimited).string(message.info[k]).join();
      }
      /* string name = 3; */


      if (message.name !== "") writer.tag(3, WireType.LengthDelimited).string(message.name);
      /* string remote_ip = 4; */

      if (message.remoteIp !== "") writer.tag(4, WireType.LengthDelimited).string(message.remoteIp);
      /* google.protobuf.Timestamp updated = 5; */

      if (message.updated) Timestamp.internalBinaryWrite(message.updated, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
      /* string provider = 6; */

      if (message.provider !== "") writer.tag(6, WireType.LengthDelimited).string(message.provider);
      /* bool verified = 7; */

      if (message.verified !== false) writer.tag(7, WireType.Varint).bool(message.verified);
      /* string key_id = 8; */

      if (message.keyId !== "") writer.tag(8, WireType.LengthDelimited).string(message.keyId);
      /* google.protobuf.Timestamp created = 9; */

      if (message.created) Timestamp.internalBinaryWrite(message.created, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return LoggedDevice$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.txauth.common.device.LoggedDevice
 */


export var LoggedDevice = new LoggedDevice$Type(); // @generated message type with reflection information, may provide speed optimized methods

var Device$Type = /*#__PURE__*/function (_MessageType2) {
  _inherits(Device$Type, _MessageType2);

  var _super2 = _createSuper(Device$Type);

  function Device$Type() {
    _classCallCheck(this, Device$Type);

    return _super2.call(this, "proto.txauth.common.device.Device", [{
      no: 1,
      name: "local_id",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "name",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "info",
      kind: "map",
      K: 5
      /*ScalarType.INT32*/
      ,
      V: {
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/

      }
    }]);
  }

  _createClass(Device$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        localId: "",
        name: "",
        info: {}
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag5 = reader.tag(),
            _reader$tag6 = _slicedToArray(_reader$tag5, 2),
            fieldNo = _reader$tag6[0],
            wireType = _reader$tag6[1];

        switch (fieldNo) {
          case
          /* string local_id */
          1:
            message.localId = reader.string();
            break;

          case
          /* string name */
          2:
            message.name = reader.string();
            break;

          case
          /* map<int32, string> info */
          3:
            this.binaryReadMap3(message.info, reader, options);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "binaryReadMap3",
    value: function binaryReadMap3(map, reader, options) {
      var len = reader.uint32(),
          end = reader.pos + len,
          key,
          val;

      while (reader.pos < end) {
        var _reader$tag7 = reader.tag(),
            _reader$tag8 = _slicedToArray(_reader$tag7, 2),
            fieldNo = _reader$tag8[0],
            wireType = _reader$tag8[1];

        switch (fieldNo) {
          case 1:
            key = reader.int32();
            break;

          case 2:
            val = reader.string();
            break;

          default:
            throw new globalThis.Error("unknown map entry field for field proto.txauth.common.device.Device.info");
        }
      }

      map[key !== null && key !== void 0 ? key : 0] = val !== null && val !== void 0 ? val : "";
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string local_id = 1; */
      if (message.localId !== "") writer.tag(1, WireType.LengthDelimited).string(message.localId);
      /* string name = 2; */

      if (message.name !== "") writer.tag(2, WireType.LengthDelimited).string(message.name);
      /* map<int32, string> info = 3; */

      for (var _i2 = 0, _Object$keys2 = Object.keys(message.info); _i2 < _Object$keys2.length; _i2++) {
        var k = _Object$keys2[_i2];
        writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k)).tag(2, WireType.LengthDelimited).string(message.info[k]).join();
      }

      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return Device$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.txauth.common.device.Device
 */


export var Device = new Device$Type();